import { AlertTriangle, CalendarClock, CircleDollarSign, Lock, TrendingDown, UserX } from "lucide-react";
import { nomeDoMes } from "@bookdental/schemas";
import { reais, type MesDaVisao } from "@/lib/dinheiro";

type Alerta = { icone: typeof AlertTriangle; texto: string; aba: string; cor: string };

/** O que pede atenção agora; cada item leva à aba onde se resolve. */
export function Alertas({ alertas, onIr }: { alertas: MesDaVisao["alertas"]; onIr: (aba: string) => void }) {
  const lista: Alerta[] = [];
  if (alertas.vencidas.quantidade)
    lista.push({ icone: AlertTriangle, cor: "text-red-600", aba: "pagar", texto: `${alertas.vencidas.quantidade} ${alertas.vencidas.quantidade === 1 ? "conta vencida" : "contas vencidas"} (${reais(alertas.vencidas.valorCents)})` });
  if (alertas.vencendo.quantidade)
    lista.push({ icone: CalendarClock, cor: "text-amber-600", aba: "pagar", texto: `${alertas.vencendo.quantidade} ${alertas.vencendo.quantidade === 1 ? "conta vence" : "contas vencem"} nos próximos 7 dias (${reais(alertas.vencendo.valorCents)})` });
  if (alertas.clientesEmAtraso)
    lista.push({ icone: UserX, cor: "text-red-600", aba: "receber", texto: `${alertas.clientesEmAtraso} ${alertas.clientesEmAtraso === 1 ? "cliente com extrato atrasado" : "clientes com extrato atrasado"} há mais de 30 dias` });
  if (alertas.semPreco)
    lista.push({ icone: CircleDollarSign, cor: "text-amber-600", aba: "receber", texto: `${alertas.semPreco} ${alertas.semPreco === 1 ? "serviço concluído sem preço" : "serviços concluídos sem preço"} neste mês` });
  for (const nome of alertas.abaixoDoCusto) lista.push({ icone: TrendingDown, cor: "text-red-600", aba: "visao", texto: `${nome}: o material custou mais do que o preço cobrado` });

  if (alertas.mesAnteriorAberto) {
    const mes = nomeDoMes(alertas.mesAnteriorAberto);
    lista.push({ icone: Lock, cor: "text-zinc-500", aba: "configuracoes", texto: `${mes.charAt(0).toUpperCase()}${mes.slice(1)} ainda não foi fechado` });
  }
  if (!lista.length) return null;
  return (
    <section className="rounded-xl border border-amber-200 bg-amber-50/60 p-3 dark:border-amber-500/30 dark:bg-amber-500/5">
      <ul className="space-y-1.5">
        {lista.map((a) => (
          <li key={a.texto}>
            <button type="button" onClick={() => a.aba !== "visao" && onIr(a.aba)} className="flex items-center gap-2 text-left text-sm text-zinc-800 hover:underline dark:text-foreground">
              <a.icone className={`h-4 w-4 shrink-0 ${a.cor}`} />
              {a.texto}
            </button>
          </li>
        ))}
      </ul>
    </section>
  );
}
